import { render, staticRenderFns } from "./RowBlockInvoiceForClientByAdmin.vue?vue&type=template&id=40520b09&"
import script from "./RowBlockInvoiceForClientByAdmin.vue?vue&type=script&lang=js&"
export * from "./RowBlockInvoiceForClientByAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports